import { IAction } from 'shared/interface/state';
import AuthService from 'shared/services/auth.service';

import * as actionTypes from 'store/actionTypes';
import { IAuthState, IProfileData, IUserData } from '../interface/auth';

export const initialState: IAuthState = {
	isLogin: AuthService.isLogin(),
	userData: AuthService.getAuthData() || ({} as IUserData),
	profileData: {} as IProfileData
};

const reducer = (state: IAuthState = initialState, action: IAction) => {
	switch (action.type) {
		case actionTypes.AUTH_SUCCESS:
			return {
				...state,
				isLogin: true
			};
		case actionTypes.AUTH_FAILED:
			return {
				...state,
				isLogin: false
			};
		case actionTypes.UPDATE_USER_DATA:
			return {
				...state,
				userData: action.payload
			};
		case actionTypes.LOGOUT:
			return {
				...state,
				isLogin: false,
				userData: {}
			};
		case actionTypes.USER_PROFILE_DATA:
			return {
				...state,
				profileData: action.payload
			};

		default:
			return state;
	}
};

export default reducer;
